import { render } from "./WorldHome.vue?vue&type=template&id=14cfc75e&scoped=true"
import script from "./WorldHome.vue?vue&type=script&lang=js"
export * from "./WorldHome.vue?vue&type=script&lang=js"

import "./WorldHome.vue?vue&type=style&index=0&id=14cfc75e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-14cfc75e"

export default script